import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { STATIC_IMAGES } from '../../app.config.vars/staticImages';
import { useSelector } from 'react-redux';
import { selectIsOnline } from '../../store/slices/global';
const OfflineModeIndicator = () => {
    const isOnline = useSelector(selectIsOnline);
    return (!isOnline && (_jsx("div", { className: "internet-connection-indicator", children: _jsx("img", { src: localStorage.getItem(STATIC_IMAGES.noInternet.key) || undefined, alt: "no inernet connection" }) })));
};
export default OfflineModeIndicator;
